const ErroCode = {
    301: "검색된 회원정보가 없습니다.",
    302: "접근 권한이 없습니다.",
    305: "검색결과가 존재하지 않습니다.",
    306: "존재하지 않는 항목입니다.",
    402: "잘못된 접근 경로입니다.",
    401: "잘못된 정보가 포함되어 있습니다.",
    400: "정보 처리 중 오류가 발생하였습니다.",
    202: "입력한 이메일 주소로 아이디가 발송 되었습니다.",
    201: "입력한 이메일 주소로 임시 패스워드가 발송 되었습니다.",
    200: "정보 처리가 완료 되었습니다.",
    101: "아이디 및 패스워드를 확인해주세요.",
    102: "필수 파라메터값을 확인해주세요.",
    103: "이미 사용 중인 아이디 입니다.",
    104: "이미 사용 중인 이메일 입니다.",
    600: "잘못된 확장자입니다.",
    601: "파일 용량을 초과했습니다.",
    602: "제한 범위를 초과했습니다.",
}

export default ErroCode;
